/**
 * O logotipo é o próprio jogo: `ENTRE` na horizontal e `LETRAS` cruzando pelo
 * `E` — o `E` de `ENTRE` é também o `E` de `LETRAS`, exatamente como uma
 * jogada. Por isso o `L` fica **acima** da linha e `TRAS` desce como haste.
 *
 * O desenho é feito com grid, e não com posicionamento absoluto, para que ele
 * acompanhe o tamanho da fonte sem números mágicos. A célula compartilhada é o
 * `E`: ele aparece uma vez só no DOM e pertence às duas palavras — o mesmo que
 * acontece no tabuleiro.
 *
 * Para quem lê com leitor de tela, tudo isso é ruído: o `aria-label` no `h1`
 * diz "Entreletras" e as letras ficam escondidas.
 */
export function Marca({
  /**
   * Segunda aparição da marca na mesma tela — hoje, o modal de carregamento
   * (§17). Dois `h1` seriam dois títulos de página, e o nome do jogo já está
   * na barra: aqui o desenho é só desenho, e quem anuncia é o texto ao lado.
   */
  decorativa = false,
}: {
  decorativa?: boolean;
} = {}) {
  const Etiqueta = decorativa ? 'p' : 'h1';
  const horizontal = [...'ENTR'];
  // O `E` de `ENTRE` é o segundo caractere de `LETRAS`: sobra o `L` em cima e
  // `TRAS` embaixo.
  const haste = [...'TRAS'];

  return (
    <Etiqueta
      className="marca"
      {...(decorativa ? { 'aria-hidden': true } : { 'aria-label': 'Entreletras' })}
    >
      <span className="marca__grade" aria-hidden="true">
        <span className="marca__letra marca__letra--haste" style={{ gridColumn: 5, gridRow: 1 }}>
          L
        </span>

        {horizontal.map((letra, i) => (
          <span key={`h${i}`} className="marca__letra" style={{ gridColumn: i + 1, gridRow: 2 }}>
            {letra}
          </span>
        ))}

        <span className="marca__letra marca__letra--cruzada" style={{ gridColumn: 5, gridRow: 2 }}>
          E
        </span>

        {/* A haste desce esmaecendo: dá a ideia do cruzamento sem virar um
            bloco de texto sobre o tabuleiro. A opacidade vem do índice porque
            é uma progressão, não quatro decisões independentes. */}
        {haste.map((letra, i) => (
          <span
            key={`v${i}`}
            className="marca__letra marca__letra--haste"
            style={{ gridColumn: 5, gridRow: i + 3, opacity: 0.62 - i * 0.14 }}
          >
            {letra}
          </span>
        ))}
      </span>
    </Etiqueta>
  );
}
